export default
{
    'Trang chủ': '首页',
    'Phim Bộ': '电视剧',
    'Phim Lẻ': '电影',
    'Quốc gia': '国家',
    'Sắp chiếu': '即将上映',
    'Ngôn ngữ': '语言',
    'Tài khoản': '账户',
    'Hành động': '动作',
    'Cổ trang': '古装',
    'Chiến tranh': '战争',
    'Tình cảm': '爱情',
    'Hài hước': '喜剧',
    'Âm nhạc': '音乐',
    'Học đường': '校园',
    'Trung Quốc': '中国',
    'Hàn Quốc': '韩国',
    'Nhật Bản': '日本',
    'Thái Lan': '泰国',
    'Ấn Độ': '印度',
    'Anh': '英国',
    'Hoạt hình': '动漫',
    'PHIM ĐỀ CỬ': '推荐电影',
    'PHIM THỊNH HÀNH': '热门电影',
    'PHIM BỘ': '电视剧',
    'PHIM LẺ': '电影',
    'PHIM HÀN QUỐC': '韩国电影',
    'PHIM TRUNG QUỐC': '中国电影',
    'Diễn viên:': '演员：',
    'Đạo diễn:': '导演：',
    'Thể loại': '类型',
    'Đánh giá:': '评分：',
    'Đề xuất cho bạn!': '为您推荐！',
    'Kết quả tìm kiếm cho': '搜索结果',
    'Xem': '观看',
    'Chia sẻ': '分享',
    'Bình luận': '评论',
    'Viết bình luận...': '写评论...',
    'Gửi': '发送',
    'Xem tất cả': '查看全部',
    'Năm': '年份',
    'Đánh giá': '评分',
  'Thời lượng': '时长',
  'Không có mô tả.': '暂无简介。',
  'Xem ngay': '立即观看',
  'Báo lỗi': '报错',
  'Xem sau': '收藏',
  'Tập ': '集 ',
  'Diễn viên': '演员',
  'Đạo diễn': '导演',
  'Thêm bình luận...': '添加评论...',
  'Bình luận không được để trống': '评论不能为空',
  'Phản hồi': '回复',
  'Gợi ý cho bạn': '为您推荐',
  'Top phim': '热门电影',
  'Phim được đề xuất': '推荐电影',
  'Dữ liệu đã được gửi tới Admin để xử lý': '数据已发送给管理员处理',
  'Đã sao chép liên kết!': '链接已复制！',
  'Không tìm thấy phim nào với từ khóa': '未找到包含该关键字的电影',
  'Về trang chủ': '返回首页',
  'Miêu tả': '描述',
  'Kết quả tìm kiếm: ': '搜索结果：',
  'Đăng ký tài khoản': '注册账户',
  'Điền thông tin bên dưới để tạo tài khoản': '填写以下信息创建账户',
  'Tên hiển thị': '显示名称',
  'Mật khẩu': '密码',
  'Xác nhận mật khẩu': '确认密码',
  'Mật khẩu không khớp': '密码不匹配',
  'Tôi đồng ý với Điều khoản & Chính sách': '我同意条款和政策',
  'Đăng ký': '注册',
  'Đăng nhập': '登录',
  'Email không được để trống': '邮箱不能为空',
  'Email không hợp lệ': '邮箱无效',
  'Đăng ký thành công! Bạn sẽ được chuyển đến trang đăng nhập.': '注册成功！您将被重定向到登录页面。',
  'Chào mừng bạn quay lại! Vui lòng đăng nhập.': '欢迎回来！请登录。',
  'Nhập email': '输入邮箱',
  'Nhập mật khẩu': '输入密码',
  'Quên mật khẩu?': '忘记密码？',
  'Chưa có tài khoản?': '还没有账户？',
  'Vui lòng nhập đầy đủ email và mật khẩu': '请输入完整的邮箱和密码',
  'Đăng nhập thành công': '登录成功',
  'Đăng nhập thất bại': '登录失败',
  'Có lỗi xảy ra': '发生错误',
  'Tên phim': '电影名称...',
  'Không tìm thấy kết quả': '未找到结果',
  'Đăng xuất': '退出登录',
  'Đổi giao diện': '切换主题',
  'Trang xem phim Online với giao diện hiện đại, thân thiện người dùng.': '具有现代、用户友好界面的在线观影网站。',
  'Nguồn phim tổng hợp từ các website lớn với đa dạng thể loại và quốc gia.': '电影资源综合自各大网站，类型丰富，国家多样。',
  'Giới thiệu': '关于我们',
  'Liên hệ': '联系我们',
  'Chính sách quyền riêng tư': '隐私政策',
  'Khiếu nại bản quyền': '版权投诉',
  'Phim mới': '最新电影',
  'Phim hay': '好看电影',
  'Phim mới chill': '轻松新片',
  'Phim 18': '18禁电影',
  'Truyện tranh 18': '18禁漫画',
  'Nettruyen': '漫画',
  'Nettruyen ngôn tình': '言情漫画',
  'Hiện đại': '现代',
  'Chính kịch': '剧情',
  'Cổ Trang': '古装',
  'Tình Cảm': '爱情',
  'Hành Động': '动作',
  'Âu Mỹ': '欧美',
  'Việt Nam': '越南',
  'TV Show': '综艺节目',

  'Danh sách phim của bạn': '您的收藏列表',
  'Bạn không có dữ liệu nào được lưu':'您没有保存任何数据',
  'Bạn muốn xem gì?': '您想看什么？',
  'Danh sách phim của bạn!': '您的收藏列表！',
  'Hết thời gian yêu cầu, vui lòng kiểm tra lại đường truyền internet': '请求超时，请检查网络连接',
  '⏳ Hết thời gian chờ. Vui lòng thử lại!': '⏳ 等待超时。请重试！',
  'Lọc':'筛选',
  'Danh sách phim:': '电影列表：',
  "Không có dữ liệu được hiển thị, vui lòng tải lại trang": "没有数据显示，请重新加载页面",
  "Hết thời gian chờ, vui lòng tải lại trang": "超时，请重新加载页面",
  "Thời gian chiếu": "上映时间",
  "Đã lưu": "已保存",
  'Bạn không có phim nào đã được lưu': '您没有保存的电影',
'Lịch chiếu':'排片表',

"BXH HTTQ THỊNH HÀNH": "热门排行榜",
"Mãn Nhãn với Phim Chiếu Rạp":"院线大片 视觉盛宴",
  "PHIM VIỆT NAM": "越南电影",
  "PHIM MỚI": "最新电影",
  "PHIM TÌNH CẢM": "爱情电影",
  "Vừa xong": "刚刚",
  "phút trước": "分钟前",
  "giờ trước": "小时前",
  "ngày trước": "天前",
  "Xem từ đầu": "从头观看",
  "Giới thiệu:": "简介：",
  "Thể loại:": "类型：",
  "Quốc gia:": "国家：",
  "Đang cập nhật": "更新中",
  "Số tập:": "集数：",
  "tập": "集",
  "Thời lượng:": "时长：",
  "Tập phim": "剧集",
  "Đề xuất": "推荐",
  "Xem thêm": "查看更多",
  "Thu gọn": "收起",
  "Chưa có bình luận nào. Hãy là người đầu tiên!": "暂无评论。快来抢沙发吧！",
  "Chưa có dữ liệu của phim này": "暂无该电影数据",
  "Vui lòng theo dõi lại sau": "请稍后关注",
  "Chủ Nhật": "星期日",
  "Thứ Hai": "星期一",
  "Thứ Ba": "星期二",
  "Thứ Tư": "星期三",
  "Thứ Năm": "星期四",
  "Thứ Sáu": "星期五",
  "Thứ Bảy": "星期六",
  "Trailer sẽ được phát trước": "将首先播放预告片",
  "Bỏ qua": "跳过",
  "Đăng nhập để bình luận": "登录后评论",
  "Danh sách tập": "剧集列表",
  "Ẩn bộ lọc": "隐藏筛选",
  "Lọc phim": "筛选电影",
  "Sắp xếp": "排序",
  "Thuyết Minh": "解说",
  "Lồng Tiếng": "配音",
  "Viễn tưởng": "科幻",
  "Kinh dị": "恐怖",
  "Bí ấn": "悬疑",
  "Phim 18+": "18+电影",
  "Tâm lý": "心理",
  "Gia đình": "家庭",
  "Hồng Kông": "香港",
  "Pháp": "法国",
  "Đức": "德国",
  "Hà Lan": "荷兰",
  "Mexico": "墨西哥",
  "Thụy điển": "瑞典",
  "Philippines": "菲律宾",
  "Châu Phi": "非洲",
  "Đài Loan": "台湾",
  "Năm ↓": "年份 ↓",
  "Thời gian cập nhật": "更新时间",
  "Vui lòng đăng nhập để sử dụng chức năng này": "请登录后使用此功能",
  "Tài khoản của bạn đã hết hạn đăng nhập": "您的账号登录已过期",
  "Click để xem phim": "点击观看电影",
  "Tập trước": "上一集",
  "Tập tiếp": "下一集",
  "Xem trailer chính thức": "观看官方预告片",
  "Chiếu rạp": "院线",

  "PHIM HOẠT HÌNH": "动漫电影",
  "Khám phá ngay": "立即探索",
  "Từ khóa nổi bật:": "热门关键字：",
  "Nguồn phim được tổng hợp tự động từ các website lớn với đa dạng thể loại và quốc gia, cập nhật liên tục 24/7.": "电影资源自动综合自各大网站，类型丰富，国家多样，24/7不间断更新。",
  "Kết nối với chúng tôi": "联系我们",
  "Hỗ trợ":"支持",
  "Chính sách riêng tư":"隐私政策",
  "FAQ":"常见问题",
  "Tải ứng dụng":"下载应用",
  'Chi tiết': '详情',
  'Tìm phim...': '搜索电影...',
  'Bạn chưa lưu phim nào':'您还没有保存任何电影',
  'Hãy khám phá và thêm phim vào danh sách yêu thích':'去探索并把电影加入收藏单吧',
  'Khám phá phim':'探索电影',
  'SÔI NỔI NHẤT':'最活跃',
  'YÊU THÍCH NHẤT':'最受欢迎',
  'THỂ LOẠI HOT':'热门类型',
  'BÌNH LUẬN MỚI':'最新评论',
  'LỊCH CHIẾU PHIM':'上映时间表',
  'PHIM CHIẾU SỚM':'提前点映',
  'Không có phim chiếu sớm':'暂无提前点映电影',
  'phim': '电影',
  'Giới thiệu về':'关于',
  'Nền tảng xem phim trực tuyến hàng đầu dành cho người yêu điện ảnh.':'专为电影爱好者打造的顶级在线观影平台。',
  'Sứ mệnh của chúng tôi':'我们的使命',
  'ra đời với mong muốn mang đến cho khán giả một không gian giải trí đỉnh cao, nơi bạn có thể thưởng thức những tác phẩm điện ảnh xuất sắc nhất từ khắp nơi trên thế giới. Chúng tôi không ngừng nỗ lực cập nhật các bộ phim bom tấn, phim truyền hình đặc sắc với chất lượng hình ảnh sắc nét và âm thanh sống động nhất.':'的诞生是为了给观众带来一个顶级的娱乐空间，在这里您可以欣赏到来自世界各地的最优秀的电影作品。我们不断努力更新热门大片和精彩的电视剧，为您提供最清晰的画质和最生动的声音。',
  'Điểm nổi bật của Zcines':'Zcines 的亮点',
  'Kho phim khổng lồ':'海量片库',
  'Hàng ngàn bộ phim đa dạng thể loại từ hành động, tình cảm, hài hước đến kinh dị, viễn tưởng.':'数千部电影涵盖动作、爱情、喜剧到恐怖、科幻等各种类型。',
  'Chất lượng Full HD & 4K': 'Full HD & 4K 画质',
  'Trải nghiệm xem phim mượt mà không giật lag nhờ hệ thống máy chủ mạnh mẽ và tối ưu.':'强大的优化服务器系统为您带来流畅不卡顿的观影体验。',
  'Cập nhật nhanh chóng':'快速更新',
  'Các tập phim mới được đồng bộ liên tục 24/7 ngay sau khi được phát hành chính thức.':'新剧集在正式发布后 24/7 连续同步更新。',
  'Liên hệ & Hỗ trợ':'联系与支持',
  'Danh sách yêu thích':'收藏列表',
  'Zcines luôn luôn lắng nghe mọi ý kiến để cải thiện và mang lại trải nghiệm tuyệt vời nhất cho bạn.':'Zcines 始终倾听您的每一个意见，不断改进，为您带来最棒的体验。',
  'Khám phá phim ngay':'立即探索电影',
  'Miền Tây':'西部',
  'Trẻ Em':'儿童',
  'Lịch Sử': '历史',
  'Tài Liệu': '纪录片',
  'Thể Thao': '体育',
  'Phiêu Lưu': '冒险',
  'Âm Nhạc': '音乐',
  'Hình Sự': '犯罪',
  'Võ Thuật': '武术',
  'Khoa Học': '科学',
  'Thần Thoại': '神话',
  'Kinh Điển':'经典',
  'Phim Ngắn': '短片',
  'Ủng hộ': '捐赠',
  'Ủng hộ chúng tôi': '支持我们',
  'Zcines hoàn toàn miễn phí và sẽ luôn như vậy. Mỗi đóng góp của bạn giúp chúng tôi duy trì máy chủ, băng thông và tiếp tục cập nhật phim mỗi ngày.':'Zcines 完全免费，并将永远免费。您的每一份捐助都帮助我们维持服务器和带宽，并持续每天更新电影。',
  'Vì sao cần sự ủng hộ của bạn?':'为什么我们需要您的支持？',
  'Chi phí vận hành một website xem phim không hề nhỏ: máy chủ, băng thông, subtitle và thời gian của đội ngũ. Quảng cáo chỉ đủ trang trải một phần. Với một ly cà phê từ bạn, chúng tôi có thể tiếp tục mang đến những bộ phim hay nhất hoàn toàn miễn phí cho mọi người.':'运营一个电影网站的成本并不低：服务器、带宽、字幕以及团队的时间。广告收入只能覆盖一部分。您的一杯咖啡，就能让我们继续免费为大家带来最精彩的电影。',
  'Hình thức ủng hộ':'捐赠方式',
  'Sao chép':'复制',
  'Nội dung chuyển khoản: UNG HO ZCINES. Sau khi chuyển khoản, bạn có thể gửi ảnh chụp biên lai qua Telegram để được xác nhận và cảm ơn.':'转账备注：UNG HO ZCINES。转账后，您可以通过 Telegram 发送收据截图以获得确认和感谢。',
  'Lời cảm ơn từ Zcines':'来自 Zcines 的感谢',
  'Cảm ơn bạn đã đồng hành cùng Zcines. Sự ủng hộ của bạn - dù lớn hay nhỏ - đều là động lực to lớn để chúng tôi tiếp tục phát triển và mang phim hay đến cho cộng đồng.':'感谢您与 Zcines 同行。您的支持——无论大小——都是我们继续发展、为社区带来好电影的巨大动力。',
  'Gửi biên lai qua Telegram':'通过 Telegram 发送收据',
  'Đã sao chép':'已复制',
  'Không thể sao chép tự động, vui lòng sao chép thủ công':'无法自动复制，请手动复制',

}
